module.exports = __webpack_public_path__ + "static/media/galleryGT (14).a991fe1c.jpg";